import { useSearchParams } from 'next/navigation';
import { getValidBackUrl } from '../helpers/getValidBackUrl';

export function useValidBackUrl(fallbackValue = '') {
  const searchParams = useSearchParams();

  const backurl = getValidBackUrl(
    searchParams?.get('backurl') ?? '',
    fallbackValue
  );

  return {
    backurl,
  };
}
